import service from './service';
import { getCmsListService } from './utils/pricing';

export * from './utils/notify';
export * from './utils/method';
export * from './utils/payment';

export const getStaticListService = () => {
  return [
    {
      label: '🏚 AutoShopee | ShopManager',
      name: 'autoshopee',
      value: service.autoshopee,
    },
    {
      label: '⛱ Extension Kit',
      name: 'extension',
      value: service.extension,
    },
    {
      label: '💡Subcheo | Follow',
      name: 'subcheo',
      value: [
        ...service.subcheo.score,
        ...service.subcheo.cloud,
      ],
    },
    {
      label: '🚀 Sao chép Tiktok / Lazada',
      name: 'tiktok-lazada',
      value: [
        ...service.tiktok,
        ...service.lazada,
      ],
    },
  ];
};

export const getListService = async () => {
  try {
    return await getCmsListService();
  } catch (error) {
    console.error({
      msg: 'CMS_PRICING_FALLBACK',
      error,
    });
    return getStaticListService();
  }
};
